module.exports = __webpack_public_path__ + "static/media/barestho_logo_desk.0a428f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/barestho_logo_desk.png
// module id = 1974
// module chunks = 19 29 30